import * as Yup from "yup";

const schema = Yup.object().shape({
    res_nome: Yup.string().required("Nome descritivo obrigatório"),
    res_proveniente: Yup.string()
        .required("Tabela Origem obrigatório")
        .matches(/^postgis.*/, "O campo deve começar com 'postgis.'"),
});

export const createAnySearchForm = async (payload: unknown) => {
    await schema.validate(payload, {
        abortEarly: false,
    });
};
